import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { GarantieDetail } from "src/app/parametrage/core/model/garanties/GarantieDetail";
import { GarantieMetadata } from "src/app/parametrage/core/model/garanties/GarantieMetadata";
import { GarantieService } from "src/app/parametrage/core/service/garantie.service";
import {
  CustomAdapter,
  CustomDateParserFormatter,
} from "src/app/shared/adapters/datepicker-adapter";

@Component({
  selector: "app-edit-garantie-detail",
  templateUrl: "./edit-garantie-detail.component.html",
  styleUrls: ["./edit-garantie-detail.component.scss"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class EditGarantieDetailComponent implements OnInit {
  form: FormGroup;
  pressButton: Boolean = false;
  requestId: number;
  //From row parameter
  garantie: GarantieDetail;
  errorMessage: string;
  submitted = false;

  garantieMetadatas: GarantieMetadata[];
  constructor(
    private fb: FormBuilder,
    private _garantieService: GarantieService,
    public activeModal: NgbActiveModal
  ) {
    this.form = this.fb.group({});
  }

  ngOnInit() {
    this.getGarantieDetailInfos();
  }

  getGarantieDetailInfos() {
    this._garantieService
      .getGarantieDetailInfos(this.garantie.id)
      .subscribe((data) => {
        console.log(data);
        this.setGarantieFrom(data);
        this.garantieMetadatas = data;
      });
  }

  setGarantieFrom(datas) {
    if (datas) {
      datas.sort((a, b) => a.position - b.position);
      const formGroupControls = {};
      datas.forEach((champ) => {
        const control = new FormControl(
          champ.valeurChamp,
          champ.obligatoire ? Validators.required : null
        );
        formGroupControls[champ.codeChamp] = control;
        //this.form.addControl(champ.codeChamp, control);
      });
      this.form = this.fb.group(formGroupControls);
    }
  }

  onSubmit() {
    this.submitted = true;

    this.findInvalidControls();
    if (this.form.invalid) {
      return;
    }
    this._garantieService
      .updateGarantieDetail(this.requestId, this.garantie.id, this.form.value)
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
        }
      );
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
        const invalidControl = this.garantieMetadatas.find(
          (n) => n.codeChamp == name
        );
        console.log(controls);
        this.errorMessage = `Le champ [${invalidControl.libelleChamp}] est obligatoire de type [${invalidControl.typeChamp}].`;
        return;
      }
    }
    //console.log(invalid);
  }
}
